import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

import VerticalSidebar from './VerticalSidebar';
import ImpersonationBanner from './ImpersonationBanner';

function ContentLoader() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-secondary-500" role="status">
      <Loader2 size={40} className="mb-4 animate-spin text-primary-500" />
      <p>Loading...</p>
    </div>
  );
}

function DashboardLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-warm-white">
      <VerticalSidebar />
      <main className="flex-1 min-w-0 md:ml-64 pt-14 md:pt-0 min-h-screen">
        <ImpersonationBanner />
        <div className="p-3 sm:p-6">
          <Suspense fallback={<ContentLoader />}>
            {children}
          </Suspense>
        </div>
      </main>
    </div>
  );
}

export default DashboardLayout;
